import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Login from './Login';

// Lado de gestión (/dashboard): un usuario con rol JUGADOR no debe entrar,
// va a su zona personal. Ojo: esto es solo experiencia de uso — los datos de
// gestión los protege el backend (401/403 por endpoint), no esta redirección.
// Quien no tiene sesión ve el login en la propia URL (sin redirigir a `/`, que
// puede estar oculto al público en la tabla `pantallas`); al entrar se queda aquí.
export default function SoloGestion({ children }) {
  const { usuario, cargando } = useAuth();

  if (cargando) return null;
  if (!usuario) return <Login />;
  if (usuario.rol === 'JUGADOR') return <Navigate to="/mi-area-personal" replace />;
  return children;
}
